import { useEffect } from 'react';
import { BrandKey, resolveBrandKey } from '@themes/aegix';
import { getBrandKeyFromAuthCookie } from '../utils/brandKeyFromJwt';

// ADR 115 Phase 5: resolve the brand via the layered resolver
// (JWT brand_key > hostname > AEGIX fallback). sms-web renders Aegix or
// SAFE+.
const isSafe =
  resolveBrandKey({
    jwtClaim: getBrandKeyFromAuthCookie(),
    hostname:
      typeof window !== 'undefined' ? window.location.hostname : undefined,
    supportedBrands: [BrandKey.Aegix, BrandKey.SafePlus],
  }) === BrandKey.SafePlus;
const appName = isSafe ? 'SAFE+ Management System' : 'Aegix SMS';

export function usePageTitle(title?: string) {
  useEffect(() => {
    document.title = title ? `${title} | ${appName}` : appName;
  }, [title]);
}
